import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header id="header" className={scrolled ? "scrolled" : ""}>
      <div className="container header-container">

        {/* Logo */}
        <div className="logo">
          <img src="/assets/logo.png" alt="logo" />
          <span className="logo-text">R Vibes Homoeopathy</span>
        </div>

        {/* Navigation */}
        <nav className={menuOpen ? "active" : ""}>
          <div className="close-menu" onClick={() => setMenuOpen(false)}>
            <i className="fas fa-times"></i>
          </div>

          <ul>
            <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
            <li><Link to="/products" onClick={() => setMenuOpen(false)}>Products</Link></li>
            <li><Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link></li>
            <li><Link to="/blog" onClick={() => setMenuOpen(false)}>Blog</Link></li>

            {/* MOBILE CONTACT BUTTON — ONLY SHOWN ON SMALL SCREENS */}
            <li className="mobile-contact">
              <a href="tel:+918979509737" className="btn btn-primary">
                <i className="fas fa-phone"></i> Contact
              </a>
            </li>
          </ul>
        </nav>

        {/* Desktop Header Icons */}
        <div className="header-icons">
          <div className="header-icon btn btn-primary desktop-contact">
            <a href="tel:+918979509737">
              <i className="fas fa-phone"></i> Contact
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="header-icon menu-toggle" onClick={() => setMenuOpen(true)}>
            <i className="fas fa-bars"></i>
          </div>
        </div>

      </div>
    </header>
  );
}
